(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

// document.addEventListener("DOMContentLoaded", (event) => {
//     const mobileMenuToggle = document.getElementById('menu-toggle');
//     const mobileMenu = document.getElementById('menu');

//     mobileMenuToggle.addEventListener('click', () => {
//         mobileMenu.classList.toggle('active');
//         mobileMenuToggle.classList.toggle('active');
//     });
// });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info"] && !window.DesignMode) return;
  try {
    
    let charToClass = {
        "@": "at", 
        ".": "dot",
        ":": "colon",
    }
    function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    let replacer = document.querySelectorAll('[data-add-accent]')[0];
    let accentChars = replacer ? replacer.dataset.addAccent : "";

    function processLeafNodes(element) {
        if (element.innerHTML && !element.hasChildNodes() && element.parentNode !== replacer) {
            console.log(typeof element);
            // replaceInnerHtml(element.parentNode);
        } else {
            element.childNodes.forEach(child => processLeafNodes(child));
        }
    }

    function replaceInnerHtml(element){
        let updatedHtml = element.innerHTML; 
        let innerText = element.innerText;
        // console.log("doing",updatedHtml)
        for (let i = 0; i < accentChars.length; i++) {
            //find if innerText contains character and if so grab the match and the two characters before and after
            let char = accentChars[i];
            let indexInText = innerText.indexOf(char);
            let chunkWithMatch = innerText.slice(indexInText - 2, indexInText + 3);
            let escapedChar = escapeRegExp(char);
            updatedHtml = updatedHtml.replace(new RegExp(escapedChar, 'g'), `${chunkWithMatch.slice(0,2)}<span class="accent char-${charToClass[char]}">${char}</span>${chunkWithMatch.slice(3)}`);
            console.log("updating",updatedHtml)
        }
        element.innerHTML = updatedHtml;
    }

    // processLeafNodes(replacer);
    
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash"] && !window.DesignMode) return;
  try {
    
    // use a script tag or an external JS file
    //get bounding box height of .logo-wrapper
    //get closest .shopify-section, and then get the following one
     // Easing function for ease-out cubic
     function easeOutCubic(t, coefficient) {
        return 1 - Math.pow(1 - t, 3 * coefficient);
    }

    
    const thisSection = document.querySelector(".splash").parentElement;
    const nextSection = document.querySelector(".splash").parentElement.nextElementSibling;
    const logoWrapper = document.querySelector(".splash-logo-wrapper");
    const endOffset = document.querySelector('.splash').offsetHeight+ logoWrapper.offsetHeight;
    function imageStartY() {
        //get offset from top of document of nextSection 
        const sectionOffset = thisSection.getBoundingClientRect().height;
        return Math.min(sectionOffset,window.innerHeight) - logoWrapper.getBoundingClientRect().height;
    }
    let imgStart = imageStartY();
    // console.log("endOffset",endOffset,document.querySelector('.splash').offsetHeight, logoWrapper.offsetHeight);
    if(window.innerWidth>768){
        logoWrapper.style.top = `${window.scrollY>imgStart ? 0:imgStart}px`;
        logoWrapper.classList.add("ready");
        document.addEventListener("DOMContentLoaded", (event) => {
        gsap.registerPlugin(ScrollTrigger);
        let end = document.querySelector('.splash').offsetHeight - logoWrapper.offsetHeight;
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".splash",
                start: "top top", // Start animation when the bottom of the splash is at the bottom of the viewport
                // end: () => `+=${end}`, // End when the top of the logo-wrapper is at the bottom of the splash
                // end: () => `+=${endOffset - logoWrapper.offsetHeight}`, // End when the top of the logo-wrapper is at the bottom of the splash
                end: window.innerWidth < 768 ? imageStartY() : endOffset,//'+=110%',
                // pin: true,
                scrub: true,
                onRefresh: () => {
                    // Update the start position on refresh
                    tl.scrollTrigger.end = `+=${endOffset - logoWrapper.offsetHeight}`;
                },
        //         onUpdate: (self) => {
        //             // Update the top position based on the progress
        //             const progress = self.progress;
        //             const startTop = imageStartY();

        //             const endTop = 0;

        //             const easedProgress = easeOutCubic(progress, 0.85); // 0.5 is the coefficient to control intensity
        //             const newTop = startTop - (startTop - endTop) * easedProgress;
        //             logoWrapper.style.top = `${newTop}px`;
        //         },
                onRefresh: () => {
                    // Update the end position on refresh
                    tl.scrollTrigger.end = `+=${document.querySelector('.splash').offsetHeight - logoWrapper.offsetHeight}`;
                }
            }
        });
        tl.fromTo(".logo-wrapper", {
            top: () => `${imageStartY()}px`, // Start position (bottom of the screen)
        }, {
            top: 0,
            scale: window.innerWidth>768 ? 0.7 : 1, // Shrink by 25%
            duration: 2, // Duration is controlled by scroll position,
            // ease: "power4.in"
        },0)
        if(window.innerWidth>768){
            tl.fromTo(".sliding-image", {
                transform: "translateY(0vh)", // Start position (outside the bottom of the screen)
            },{
                transform: "translateY(-75vh)", // Start position (outside the bottom of the screen)
                duration: 2
            },.2)
        } else {
            // ScrollTrigger.normalizeScroll(true);
        }
                
            //on resize refresh scrolltrigger
            window.addEventListener("resize", () => {
                ScrollTrigger.refresh();
            });
        }); //end of dom content loaded
    } 
    // else {
    //     const pinLogoMobile = () => {
    //         if(window.scrollY > 0){
    //             logoWrapper.classList.add("mobile-stick");
    //             window.removeEventListener("scroll", pinLogoMobile);
    //         }
    //     }
    //     //if we're on mobile, on scroll, if we're over 50 pixels down, add mobile-stick to .logo-wrapper, and remove the listener
    //     window.addEventListener("scroll", pinLogoMobile);
                
    // }
    


  } catch(e) { console.error(e); }
})();
})();
